import React from "react";

const KPICards = ({ kpis }) => {
	const formatCurrency = (amount, currency = "USD") => {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: currency,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}).format(amount || 0);
	};

	const getChangeColor = (change) => {
		if (change > 0) return "var(--success-color)";
		if (change < 0) return "var(--danger-color)";
		return "var(--text-muted)";
	};

	const getChangeIcon = (change) => {
		if (change > 0) return "↑";
		if (change < 0) return "↓";
		return "→";
	};

	const cards = [
		{
			title: "Our Revenue",
			value: formatCurrency(kpis.ourRevenueUSD),
			change: kpis.ourRevenueChange,
			icon: "💰",
			color: "var(--success-color)"
		},
		{
			title: "Partner Reported",
			value: formatCurrency(kpis.partnerReportedUSD),
			change: kpis.partnerReportedChange,
			icon: "📊",
			color: "var(--info-color)"
		},
		{
			title: "User Payout",
			value: formatCurrency(kpis.userPayoutUSD),
			change: kpis.userPayoutChange,
			icon: "👥",
			color: "var(--warning-color)"
		},
		{
			title: "Our Margin",
			value: formatCurrency(kpis.ourMarginUSD),
			change: kpis.ourMarginChange,
			icon: "📈",
			color: "var(--primary-color)"
		},
		{
			title: "Received",
			value: formatCurrency(kpis.receivedUSD),
			subtitle: `${kpis.receivedPercentage}% of invoiced`,
			icon: "✅",
			color: "var(--success-color)"
		}
	];

	return (
		<div style={{
			display: "grid",
			gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
			gap: "var(--spacing-lg)"
		}}>
			{cards.map((card, index) => (
				<div
					key={index}
					className="card-refer-stat-v4"
					style={{
						borderLeft: `4px solid ${card.color}`,
						position: "relative",
						overflow: "hidden"
					}}
				>
					<div style={{
						fontSize: "32px",
						marginBottom: "var(--spacing-sm)",
						opacity: 0.8
					}}>
						{card.icon}
					</div>
					<div className="card-stat-value-v4" style={{ color: card.color }}>
						{card.value}
					</div>
					<div className="card-stat-label-v4" style={{ marginBottom: "var(--spacing-xs)" }}>
						{card.title}
					</div>
					{card.change !== undefined && (
						<div style={{
							fontSize: "12px",
							fontWeight: "600",
							color: getChangeColor(card.change),
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: "4px"
						}}>
							<span>{getChangeIcon(card.change)}</span>
							<span>{Math.abs(card.change).toFixed(1)}%</span>
						</div>
					)}
					{card.subtitle && (
						<div style={{
							fontSize: "11px",
							color: "var(--text-muted)",
							marginTop: "4px"
						}}>
							{card.subtitle}
						</div>
					)}
				</div>
			))}
		</div>
	);
};

export default KPICards;